module.exports = __webpack_public_path__ + "img/支付背景.a7703c92.png";